module.exports = __webpack_public_path__ + "img/header_bg.50b5fbd5.png";